function HospitalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="38"
      viewBox="0 0 44 38"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 36.1279C0 35.5834 0.442054 35.144 0.983853 35.144H42.1821C42.7266 35.144 43.166 35.5861 43.166 36.1279C43.166 36.6697 42.7239 37.1118 42.1821 37.1118H0.983853C0.439359 37.1118 0 36.6697 0 36.1279Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89246 6.78487C5.6687 6.78487 4.67136 7.78221 4.67136 9.00598V35.1417H38.271V9.00598C38.271 7.81726 37.3518 6.84687 36.1765 6.78487H26.6317C26.0872 6.78487 25.6478 6.34281 25.6478 5.80101C25.6478 5.25921 26.0899 4.81715 26.6317 4.81715H36.1981C36.2116 4.81715 36.2278 4.81715 36.2412 4.81715C38.4893 4.91688 40.236 6.7687 40.236 9.00598V36.1282C40.236 36.6727 39.7939 37.1121 39.2521 37.1121H3.6821C3.1376 37.1121 2.69824 36.67 2.69824 36.1282V9.00598C2.69824 6.69592 4.57701 4.81445 6.88976 4.81445H16.7095C17.254 4.81445 17.6934 5.25652 17.6934 5.79832C17.6934 6.34011 17.2513 6.78218 16.7095 6.78218H6.88976L6.89246 6.78487Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8845 27.6047V35.1414H29.3352V27.6182C29.3352 26.85 28.6909 26.2058 27.9227 26.2058H15.2996C14.5368 26.2058 13.906 26.8203 13.8872 27.6047H13.8845ZM11.9141 27.5751C11.9491 25.7368 13.437 24.2354 15.2969 24.2354H27.92C29.7772 24.2354 31.3029 25.761 31.3029 27.6182V36.1253C31.3029 36.6698 30.8608 37.1091 30.319 37.1091H12.9006C12.3561 37.1091 11.9168 36.6671 11.9168 36.1253V27.5724L11.9141 27.5751Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5019 24.2383C22.0464 24.2356 22.4885 24.6723 22.4939 25.2168L22.5693 36.0959C22.572 36.6403 22.1354 37.0824 21.5909 37.0878C21.0464 37.0905 20.6043 36.6538 20.5989 36.1093L20.5234 25.2302C20.5208 24.6857 20.9574 24.2437 21.5019 24.2383Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0166 19.3188V21.4887H32.1354V19.3188H25.0166Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8789 19.3188V21.4887H17.9978V19.3188H10.8789Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0166 13.1274V15.2973H32.1354V13.1274H25.0166Z"
        fill="var(--purple-700)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8789 13.1274V15.2973H17.9978V13.1274H10.8789Z"
        fill="var(--purple-700)"
      />
      <path
        d="M21.5342 0C17.9491 0 15.0703 2.90307 15.0703 6.46384C15.0703 10.0246 17.9734 12.9277 21.5342 12.9277C25.0949 12.9277 27.998 10.0246 27.998 6.46384C27.998 2.90307 25.1192 0 21.5342 0ZM24.6637 7.82777C24.6637 7.90324 24.6124 7.95446 24.537 7.95446H23.0976C23.0221 7.95446 22.9709 8.00567 22.9709 8.08115V9.52055C22.9709 9.59602 22.9197 9.64724 22.8442 9.64724H20.1675C20.0921 9.64724 20.0408 9.59602 20.0408 9.52055V8.05689C20.0408 7.98141 19.9896 7.9302 19.9142 7.9302H18.4747C18.3993 7.9302 18.3481 7.87898 18.3481 7.80351V5.15382C18.3481 5.07835 18.3993 5.02713 18.4747 5.02713H19.9142C19.9896 5.02713 20.0408 4.97592 20.0408 4.90044V3.46104C20.0408 3.38556 20.0921 3.33435 20.1675 3.33435H22.8442C22.9197 3.33435 22.9709 3.38556 22.9709 3.46104V4.90044C22.9709 4.97592 23.0221 5.02713 23.0976 5.02713H24.537C24.6124 5.02713 24.6637 5.07835 24.6637 5.15382V7.83046V7.82777Z"
        fill="var(--purple-700)"
      />
    </svg>
  );
}

export default HospitalIcon;
